//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../../common/definitionHelper';

import { LayoutContext } from '../../../common/contexts';
//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            // overflow: 'hidden',
        },
        aboutUsContent: {
            padding: '0px 20px',
            overflowY: 'scroll',
            overflowX: 'hidden',
            height: 530,
            [theme.breakpoints.down('md')]: { height: '700px' },
            [theme.breakpoints.down('sm')]: { height: '570px' },

            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
        paragraphText: { fontSize: 16, fontWeight: 400 },
        heading: { fontSize: 18 },
        sidebarHeading: {
            fontWeight: 'bold',
            fontSize: 18,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 15,
            cursor: 'pointer',
            borderLeft: '4px solid rgba(255, 255, 255, 1)',
            '&:hover': { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' },
        },
        tableContainer: { border: '1px solid black', width: '100%', borderCollapse: 'collapse' },
        tableRowName: { border: '1px solid black', padding: '5px 10px 10px 10px', width: '40%' },
        tableRow: { border: '1px solid black', padding: '5px 10px 10px 10px' },
        HERELink: { href: '/FAQ/terms', target: '_blank' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        privacyLink: { href: 'mailto:eliu@afootinthedoor.work', target: '_blank' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const PrivacyPolicyContent = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    const [OpenDropdown, setOpenDropdown] = useState(false);
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, setOpenDropdown, OpenDropdown });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.aboutUsContent}>
            <div>
                <h3>Privacy Policy</h3>
            </div>
            <div>
                <p {...defns.paragraphText}>
                    <i>Last updated: November 3, 2025</i>
                </p>
                <p {...defns.paragraphText}>
                    A Foot in the Door, Inc. ("us", "we", or "our") operates www.afootinthedoor.work(the "Site"). We take your privacy very seriously. Please read this privacy
                    policy carefully as it contains important information on who we are, how and why we collect, store, use, and share your personal information. It also explains
                    your rights in relation to your personal information and how to contact us or supervisory authorities in the event you have a complaint.
                    <br />
                    <br />
                    We collect, use, and are responsible for certain Personal Information which is used only for providing services and improving the Site. When we do so we are
                    subject to various laws in the United States, the Personal Information Protection and Electronic Documents Act (PIPEDA) which applies in Canada, the Federal law
                    on Protection of Personal Data in the Possession of Private Parties (FLPPDPPP) which applies in Mexico, and the General Data Protection Regulation (GDPR) which
                    applies across the European Union (including in the United Kingdom), and we are responsible as “controller” of that personal information for the purposes of
                    those laws. IMPORTANT: BY USING THE SITE AND/OR OFFERINGS AVAILABLE ON THIS SITE, YOU GIVE YOUR CONSENT THAT ALL PERSONAL DATA THAT YOU SUBMIT MAY BE PROCESSED
                    BY US IN THE MANNER AND FOR THE PURPOSES DESCRIBED BELOW. IF YOU DO NOT AGREE TO THESE TERMS AND CONDITIONS, DO NOT USE THE SITE.
                    <br />
                    <br />
                    Further, you acknowledge that this Privacy Policy is designed to be read in connection with the Site Terms and Conditions of Use, which is available{' '}
                    <a href="/home/FAQ/terms" target="_blank">
                        HERE
                    </a>{' '}
                    and that by accessing or using our Site, you agree to be bound by the Site’s terms and conditions, as well as this Policy.
                    <br />
                    <br />
                    We reserve the right to change this Privacy Policy from time to time. We will notify you about significant changes in the way we treat personal information by
                    sending a notice to the primary email address specified in your account, by placing a prominent notice on our site, and by updating any privacy information on
                    this page. Your continued use of the Site and or Services available through this Site after such modifications will constitute your: (a) acknowledgment of the
                    modified Policy; and (b) your agreement to abide and be bound by that Policy.
                    <br />
                    <br />
                    <strong {...defns.heading}>Information Collection and Use</strong> <br />
                    While using our Site, we may ask you to provide us with certain personally identifiable information (“PII”) that can be used to contact or identify you. PII
                    lets us know the specifics of who you are. When you engage in certain activities on this Site, such as registering for an account, downloading a resource,
                    submitting content and/or posting content, or sending us feedback, we may ask you to provide certain information about yourself.
                    <br />
                    <br />
                    PII may include, but is not limited to, first and last name, email address, mailing address (including zip code), employer, job title and department, telephone
                    number, image and likeness, voice, and other identifying information. While using our Site, we may ask you to provide us with certain personally identifiable
                    information(“PII”) that can be used to contact or identify you. PII lets us know the specifics of who you are. When you engage in certain activities on this
                    Site, such as registering for an account, downloading a resource, submitting content and/or posting content, or sending us feedback, we may ask you to provide
                    certain information about yourself. <br /> PII may include, but is not limited to, first and last name, email address, mailing address (including zip code),
                    employer, job title and department, telephone number, image and likeness, voice, and other identifying information.
                    <br />
                    <br />
                    <strong {...defns.heading}> How Your Personal Information is Collected & Usage Data</strong> <br />
                    We collect most of this personal information directly from you—in person, by telephone, text or email and/or via our website and apps. However, like many site
                    operators, we collect information that your browser sends whenever you visit our Site ("Usage Data").
                    <br />
                    <br />
                    This Usage Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you
                    visit, the time and date of your visit, the time spent on those pages and other statistics.
                    <br />
                    <br />
                    When You access the Site by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile
                    device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use,
                    unique device identifiers and other diagnostic data.
                    <br />
                    <br />
                    We may also collect, or our third-party advertising partners may collect, certain Aggregate Information. For example, we may use your IP address to diagnose
                    problems with our servers, software, to administer our Site and to gather demographic information. Our third-party advertising partners may also provide us with
                    aggregate, but not individual, reports that will tell us how many ads were presented and clicked upon at out Site.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Information from Third-Party Social Media Services</strong> <br />
                    The Company allows You to create an account and log in to use the Service through the following Third-party Social Media Services:
                    <ul>
                        <li>YouTube</li>
                        <li>LinkedIn</li>
                        <li>Instagram</li>
                        <li>Facebook</li>
                        <li>Twitter</li>
                        <li>Pinterest</li>
                    </ul>
                    If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We may collect PII that is already associated with your
                    Third-Party Social Media Service's account, such as your name, your email address, your activities or your contact list associated with that account.
                    <br />
                    <br />
                    You may also have the option of sharing additional information with Us through Your Third-Party Social Media Service's account. If You choose to provide such
                    information and Personal Data, during registration or otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with
                    this Privacy Policy.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Communications </strong> <br />
                    We may use your Personal Information to contact you with newsletters, marketing or promotional materials, exclusive offers, surveys, and information about new
                    services or products unless you have opted not to receive such information.
                    <br />
                    <br />
                    We will always treat your personal information with the utmost respect and never sell or share it with other organizations for marketing purposes.
                    <br />
                    <br />
                    You have the right to modify or opt out of receiving promotional communications at any time by:
                    <ul>
                        <li>
                            contacting us at <a {...defns.privacyLink}>eliu@afootinthedoor.work</a>
                        </li>
                        <li>using the ‘unsubscribe' link in emails or ‘STOP' number in texts</li>
                    </ul>
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Cookies</strong> <br />
                    Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on
                    your computer's hard drive.
                    <br />
                    <br />
                    Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                    However, if you do not accept cookies, you may not be able to use some portions of our Site.
                    <br />
                    <br />
                    We may also use an outside advertising partner to display banner advertisements on our Site. As part of their service, they will place a separate cookie on your
                    computer. We will not provide any third-party advertising partners with any of your PII or information about your account or invite-code access. (Employers are
                    no longer required to submit any payment or billing information to use the Site. Access to employer-specific features is provided free of charge but requires a
                    valid invite code issued by A Foot in the Door Inc.) We and our third-party ad server will collect and use Aggregate Information about you, such as your IP
                    address, browser type, the server your computer is logged onto, the area code and zip code associated with your server and whether you responded to a particular
                    ad. Other advertisers may also place banner ads on our Site in the same manner as above, but we will not disclose any PII to them.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Security - Where Your Personal Information is Held & How Long Your Personal Information Will Be Kept</strong> <br />
                    The security of your PII is important to us but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. We
                    strive to take appropriate security measures to protect against unauthorized access to, or unauthorized alteration, disclosure, or destruction of your PII.
                    Specifically:
                    <br />
                    <ul>
                        <li>
                            We work hard to ensure that the data we collect is reliable, accurate, complete, and current. We encrypt all PII, to prevent unauthorized parties from
                            viewing such information when it is transmitted to us. We also only keep collected information only for as long as reasonably necessary and use it only
                            for the purposes for which it was collected or to comply with any applicable legal or ethical reporting or document retention requirements.
                        </li>
                        <li>
                            We limit access to PII only to specific employees, contractors and agents who have a reasonable need access to your information. For example, we may
                            provide members of our technical support team with limited access to your account to allow them to troubleshoot problems you may be having with the
                            Site. These individuals are bound by confidentiality obligations and may be subject to discipline, including termination and criminal prosecution, if
                            they fail to meet these obligations.
                        </li>
                        <li>
                            Additionally, we also employ a number of physical, electronic, and procedural safeguards to protect PII. Our secure servers and our data centers are
                            protected by industry-standard encryption, and our servers reside behind firewalls and employ high-level password protection.
                        </li>
                        <li>
                            Information may be held at our offices and those of our third party agencies, service providers, representatives and agents as described in this Privacy
                            Policy and Terms and Conditions of Use.
                            <br />
                            Some of these third parties may be based outside the European Economic Area. For more information, including on how we safeguard your personal
                            information when this occurs, see below: Transferring Your Personal Information Out of the EEA.
                        </li>
                        <li>
                            Finally, access by you to your PII is available through a password and unique account ID selected by you. This password is encrypted. We recommend that
                            you do not divulge your password to anyone.
                        </li>
                    </ul>
                    Because <i>A Foot in the Door Inc.</i> no longer collects or processes any payment information, no credit-card or billing data is stored or transmitted.
                    Employer accounts access the Site’s features using invite codes rather than payment credentials.
                    <br />
                    <br />
                    Again, as no data transmission over the Internet or any wireless network can be guaranteed to be 100% secure. As a result, while we strive to protect your PII,
                    you acknowledge that: (a) there are security and privacy limitations inherent to the Internet which are beyond our control; and (b) the security, integrity, and
                    privacy of any and all information and data exchanged between you and us through this Site cannot be guaranteed.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>ADDITIONAL PRIVACY TERMS</strong> <br />
                    <strong {...defns.heading}>Your Rights Under the GDPR</strong> <br />
                    For users in the European Union, we adhere to the Regulation (EU) 2016/679 of the European Parliament and of the Council of April 27, 2016, known as the General
                    Data Protection Regulation (the “GDPR”). For users in the United Kingdom, we adhere to the GDPR as enshrined in the Data Protection Act 2018.
                    <table {...defns.tableContainer}>
                        <tr>
                            <td {...defns.tableRowName}>Right to Access</td>
                            <td {...defns.tableRow}>The right to be provided with a copy of your personal information (the right of access)</td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Right to Rectification</td>
                            <td {...defns.tableRow}>The right to require us to correct any mistakes in your personal information</td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Right to be Forgotten</td>
                            <td {...defns.tableRow}>The right to require us to delete your personal information—in certain situations</td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Right to Restriction of Processing</td>
                            <td {...defns.tableRow}>
                                The right to require us to restrict processing of your personal information—in certain circumstances, e.g. if you contest the accuracy of the data
                            </td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Right to Data Portability</td>
                            <td {...defns.tableRow}>
                                The right to receive the personal information you provided to us, in a structured, commonly used and machine-readable format and/or transmit that
                                data to a third party—in certain situations
                            </td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Right to Object</td>
                            <td {...defns.tableRow}>
                                The right to object:
                                <ul style={{ listStyleType: 'none' }}>
                                    <li> - at any time to your personal information being processed for direct marketing (including profiling);</li>
                                    <br />
                                    <li>
                                        - in certain other situations to our continued processing of your personal information, e.g. processing carried out for the purpose of our
                                        legitimate interests.
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Right Not to be Subject to Automated Individual Decision-Making</td>
                            <td {...defns.tableRow}>
                                The right not to be subject to a decision based solely on automated processing (including profiling) that produces legal effects concerning you or
                                similarly significantly affects you
                            </td>
                        </tr>
                    </table>
                    For further information on each of those rights, including the circumstances in which they apply, see the guidance from the UK Information Commissioner's Office
                    (ICO) on individual rights under the General Data Protection Regulation.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Transferring Your Personal Information Out of the EEA (for users located in the EEA).</strong> <br />
                    To deliver services, it is sometimes necessary for us to share your personal information outside the European Economic Area (EEA), e.g.:
                    <ul>
                        <li>With our offices in the United States;</li>
                        <li>With your and our service providers located outside the EEA;</li>
                        <li>If you are based outside the EEA; or</li>
                    </ul>
                    These transfers are subject to special rules under European and UK data protection law. We will ensure the transfer complies with data protection law and all
                    personal information will be secure.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>How to File a GDPR Complaint.</strong> We hope that we can resolve any query or concern you raise about our use of your information.
                    The GDPR also gives you right to lodge a complaint with a supervisory authority, in the European Union (or European Economic Area) state where you work,
                    normally live, or where any alleged infringement of data protection laws occurred.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Your Rights Under PIPEDA</strong>
                    <br />
                    Some or all of the Personal Information we collect may be stored or processed in jurisdictions outside of Canada, namely the United States. As a result, this
                    information may be subject to access requests from local, state, and federal governments, courts, or law enforcement agencies in the U.S according to laws in
                    those jurisdictions.
                    <br />
                    <br />
                    Access and Rectification: You have a right to access your personal information and to request a correction to it if you believe it is inaccurate. If you have
                    submitted personal information and would like to have access to it, or if you would like to have it corrected, please contact us using the contact information
                    provided below. We may require you verify your identity before allowing you to access your personal information.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Your Rights Under FLPPDPPP</strong>
                    <br />
                    In accordance with the FLPPDPPP, you, at all times, have rights to access, rectification, cancellation, and opposition (the “ARCO Rights”) your personal data.
                    <br />
                    <br />
                    The owner of personal data is aware that the exercising of their rights of opposition or cancellation may render the provision of services impossible.
                    Therefore, We shall not be responsible for any ARCO rights request which would prevent the provision of a service contracted by the user.
                    <br />
                    <br />
                    For the exercising of ARCO rights, the owner must send an e-mail to the designated officer noted in the Contact Us section or, submit a written request, signed
                    by the owner of the data, sent to Our address expressing as succinctly and as clearly as possible, the request at hand. The rights request must be labeled with
                    the reference REQUEST TO EXERCISE ARCO RIGHTS and the full name of the owner of the data, as well as include a simple copy of the identity document of the owner
                    of the personal data, to ensure the identity thereof.
                    <br />
                    <br />
                    If the rights request is made by a person other than the owner, this person must be able to demonstrate that they are an authorized agent of the owner with
                    sufficient proof, as well as to attach copies of the identity documents of the owner of the data and the agent.
                    <br />
                    <br />
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Your Rights Under the CCPA</strong>
                    <br />
                    You have the right under the California Consumer Privacy Act of 2018 (CCPA) and certain other privacy and data protection laws, as applicable, to exercise free
                    of charge:
                    <br />
                    <table {...defns.tableContainer}>
                        <tr>
                            <td {...defns.tableRowName}>Disclosure of Personal Information We Collect About You</td>
                            <td {...defns.tableRow}>
                                You have the right to know:
                                <ul>
                                    <li>The categories of personal information we have collected about you;</li>
                                    <li>The categories of sources from which the personal information is collected;</li>
                                    <li>Our business or commercial purpose for collecting or selling personal information;</li>
                                    <li>The categories of third parties with whom we share personal information, if any; and</li>
                                    <li>The specific pieces of personal information we have collected about you.</li>
                                    <li>Please note that we are not required to:</li>
                                    <li>
                                        Retain any personal information about you that was collected for a single one-time transaction if, in the ordinary course of business, that
                                        information about you is not retained;
                                    </li>
                                    <li>
                                        Reidentify or otherwise link any data that, in the ordinary course of business, is not maintained in a manner that would be considered
                                        personal information; or
                                    </li>
                                    <li>Provide the personal information to you more than twice in a 12-month period.</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Personal Information Used for a Business Purpose</td>
                            <td {...defns.tableRow}>
                                In connection with any personal information we may disclose to a third party for a business purpose, you have the right to know:
                                <br />
                                <br />
                                The categories of personal information about you that we sold and the categories of third parties to whom the personal information was sold; and
                                <br />
                                <br />
                                The categories of personal information that we disclosed about you for a business purpose.
                                <br />
                                <br />
                                You have the right under the California Consumer Privacy Act of 2018 (CCPA) and certain other privacy and data protection laws, as applicable, to
                                opt-out of the disclosure of your personal information. If you exercise your right to opt-out of the disclosure of your personal information, we
                                will refrain from selling your personal information, unless you subsequently provide express authorization for the sale of your personal
                                information.
                            </td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Right to Deletion</td>
                            <td {...defns.tableRow}>
                                Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will:
                                <ul>
                                    <li>Delete your personal information from our records; and</li>
                                    <li>Direct any service providers to delete your personal information from their records.</li>
                                    <li>Please note that we may not delete your personal information if it is necessary to:</li>
                                    <li>
                                        Complete the transaction for which the personal information was collected, fulfill the terms of a written warranty or product recall
                                        conducted in accordance with federal law, provide a good or service requested by you, or reasonably anticipated within the context of our
                                        ongoing business relationship with you, or otherwise perform a contract between you and us;
                                    </li>
                                    <li>
                                        Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity; or prosecute those responsible for that
                                        activity;
                                    </li>
                                    <li>Debug to identify and repair errors that impair existing intended functionality;</li>
                                    <li>
                                        Exercise free speech, ensure the right of another consumer to exercise his or her right of free speech, or exercise another right provided
                                        for by law;
                                    </li>
                                    <li>Comply with the California Electronic Communications Privacy Act;</li>
                                    <li>
                                        Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other
                                        applicable ethics and privacy laws, when our deletion of the information is likely to render impossible or seriously impair the achievement
                                        of such research, provided we have obtained your informed consent;
                                    </li>
                                    <li>Enable solely internal uses that are reasonably aligned with your expectations based on your relationship with us;</li>
                                    <li>Comply with an existing legal obligation; or</li>
                                    <li>
                                        Otherwise use your personal information, internally, in a lawful manner that is compatible with the context in which you provided the
                                        information.
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td {...defns.tableRowName}>Protection Against Discrimination</td>
                            <td {...defns.tableRow}>
                                You have the right to not be discriminated against by us because you exercised any of your rights under the CCPA. This means we cannot, among other
                                things:
                                <ul>
                                    <li>Deny goods or services to you;</li>
                                    <li>Charge different prices or rates for goods or services, including through the use of discounts or other benefits or imposing penalties;</li>
                                    <li>Provide a different level or quality of goods or services to you; or</li>
                                    <li>Suggest that you will receive a different price or rate for goods or services or a different level or quality of goods or services.</li>
                                </ul>
                                Please note that we may charge a different price or rate or provide a different level or quality of goods and/or services to you, if that difference
                                is reasonably related to the value provided to our business by your personal information.
                            </td>
                        </tr>
                    </table>
                    <br />
                    Please note that since our employer platform is free and invite-only, no financial data is collected or used for billing purposes. All other personal
                    information described here applies equally to invite-based users.
                </p>
                <p {...defns.paragraphText}>
                    <strong {...defns.heading}>Contact Us</strong> <br />
                    If you have any questions, concerns, or inquiries about our Privacy Policy, or our use of your PII, or our privacy practices, or if you have questions about how
                    your information is used in connection with invite codes or account eligibility, please contact our Privacy Officer at:{' '}
                    <a {...defns.privacyLink}>eliu@afootinthedoor.work</a>
                    .
                    <br />
                    <br />
                    Please note that you may only make a CCPA-related data access or data portability disclosure request twice within a 12-month period.
                    <br />
                    <br />
                    We are not obligated to make a data access or data portability disclosure if we cannot verify that the person making the request is the person about whom we
                    collected information or is someone authorized to act on such person’s behalf. Any personal information we collect from you to verify your identity in
                    connection with you request will be used solely for the purposes of verification.
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicyContent;
